<template>
    <div>
        <pxkeji-rightHeader/>

        <div class="pxkeji-right-box">
            <a-tabs default-active-key="alipay">
                <a-tab-pane key="alipay" tab="支付宝支付">
                    <a-form :form="form" @submit="aliSubmit">
                        <a-form-item label="appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入appId"
                                    v-decorator="[
              'appId',
              {rules: [{ required: true, message: '请输入appId!' }],initialValue:info.alipay.appId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="支付公钥" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-textarea
                                    placeholder="请输入支付公钥"
                                    :rows="4"
                                    v-decorator="[
              'publicKey',
              {rules: [{ required: true, message: '请输入支付公钥!' }],initialValue:info.alipay.publicKey}
            ]"
                            ></a-textarea>
                        </a-form-item>
                        <a-form-item label="支付私钥" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-textarea
                                    placeholder="请输入支付私钥"
                                    :rows="4"
                                    v-decorator="[
              'privateKey',
              {rules: [{ required: true, message: '请输入支付私钥!' }],initialValue:info.alipay.privateKey}
            ]"
                            ></a-textarea>
                        </a-form-item>
                        <a-form-item label="回调地址" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入回调地址"
                                    v-decorator="[
              'notifyUrl',
              {rules: [{ required: true, message: '请输入回调地址!' }],initialValue:info.alipay.notifyUrl}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="验签类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-select
                                    v-decorator="[
              'signType',
              {rules: [{ required: true, message: '请选择验证类型!' }],initialValue:info.alipay.signType}
            ]"
                            >
                                <a-select-option value="RSA">RSA</a-select-option>
                                <a-select-option value="RSA2">RSA2</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
                <a-tab-pane key="wechat" tab="微信支付" force-render>
                    <a-form :form="form1" @submit="wechatSubmit">
                        <a-form-item label="商户ID" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入商户ID"
                                    v-decorator="[
              'mchId',
              {rules: [{ required: true, message: '请输入商户ID!' }],initialValue:info.wechat.mchId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="商户密钥" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入商户密钥"
                                    v-decorator="[
              'mchKey',
              {rules: [{ required: true, message: '请输入商户密钥!' }],initialValue:info.wechat.mchKey}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入appId"
                                    v-decorator="[
              'appId',
              {rules: [{ required: true, message: '请输入appId!' }],initialValue:info.wechat.appId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="小程序appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入小程序appId"
                                    v-decorator="[
              'appletsAppId',
              {rules: [],initialValue:info.wechat.appletsAppId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="公众号支付appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入公众号支付appId"
                                    v-decorator="[
              'mpAppId',
              {rules: [],initialValue:info.wechat.mpAppId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="回调地址" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入回调地址"
                                    v-decorator="[
              'notifyUrl',
              {rules: [{ required: true, message: '请输入回调地址!' }],initialValue:info.wechat.notifyUrl}
            ]"
                            ></a-input>
                            <a-form-item label="微信证书" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                                <a-textarea
                                        placeholder="请输入证书地址"
                                        :rows="4"
                                        v-decorator="[
              'keyContent',
              {rules: [{ required: true, message: '请输入证书地址!' }],initialValue:info.wechat.keyContent}
            ]"
                                ></a-textarea>
                            </a-form-item>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
                <a-tab-pane key="wxmp" tab="微信授权" force-render>
                    <a-form :form="form2" @submit="wxmpSubmit">
                        <a-form-item label="appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入appId"
                                    v-decorator="[
              'appId',
              {rules: [],initialValue:info.wxmp.appId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="secret" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入secret"
                                    v-decorator="[
              'secret',
              {rules: [],initialValue:info.wxmp.secret}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="小程序appId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入小程序appId"
                                    v-decorator="[
              'appletsAppId',
              {rules: [],initialValue:info.wxmp.appletsAppId}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item label="小程序secret" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请输入小程序secret"
                                    v-decorator="[
              'appletsSecret',
              {rules: [],initialValue:info.wxmp.appletsSecret}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>
                <a-tab-pane key="sms" tab="短信">
                    <a-form :form="form5" @submit="smsSubmit">
                        <a-form-item label="类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-select
                              v-model="info.sms.type"
                                  v-decorator="[
                                'type',
                                {rules: [{ required: true, message: '请选择类型!' }],initialValue:info.sms.type}
                              ]"
                          >
                            <a-select-option value="yimei">亿美短信服务</a-select-option>
                            <a-select-option value="aliyun">阿里云短信服务</a-select-option>
                          </a-select>
                        </a-form-item>
                        <template v-if="info.sms.type=='yimei'">
                        <a-form-item label="账户" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入账户"
                                  v-decorator="[
                          'account',
                          {rules: [{ required: true, message: '请输入账户!' }],initialValue:info.sms.account}
                        ]"
                          ></a-input>
                        </a-form-item>
                        <a-form-item label="密钥" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入密钥"
                                  v-decorator="[
                          'secret',
                          {rules: [{ required: true, message: '请输入密钥!' }],initialValue:info.sms.secret}
                        ]"
                          ></a-input>
                        </a-form-item>
                        <a-form-item label="签名" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入签名"
                                  v-decorator="[
                          'sign',
                          {rules: [{ required: true, message: '请输入签名!' }],initialValue:info.sms.sign}
                        ]"
                          ></a-input>
                        </a-form-item>

                      </template>
                      <template v-if="info.sms.type=='aliyun'">


                        <a-form-item label="账户" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入账户"
                                  v-decorator="[
                          'account',
                          {rules: [{ required: true, message: '请输入账户!' }],initialValue:info.sms.account}
                        ]"
                          ></a-input>
                        </a-form-item>
                        <a-form-item label="密钥" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入密钥"
                                  v-decorator="[
                          'secret',
                          {rules: [{ required: true, message: '请输入密钥!' }],initialValue:info.sms.secret}
                        ]"
                          ></a-input>
                        </a-form-item>
                        <a-form-item label="签名" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入签名"
                                  v-decorator="[
                          'sign',
                          {rules: [{ required: true, message: '请输入签名!' }],initialValue:info.sms.sign}
                        ]"
                          ></a-input>
                        </a-form-item>

                        <a-form-item label="模版ID" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                          <a-input
                                  placeholder="请输入模版ID"
                                  v-decorator="[
                          'template',
                          {rules: [{ required: true, message: '请输入模版ID!' }],initialValue:info.sms.template}
                        ]"
                          ></a-input>
                        </a-form-item>

                        
                      </template>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                          <pxkeji-btn name="保存" type="primary" htmlType="submit" />
                        </a-form-item>
                      </a-form>
                </a-tab-pane>

                <a-tab-pane key="chinaums" tab="银联商务">
                    <a-form :form="form4" @submit="chinaUMSSubmit">
                        <a-form-item label="商户号(mid)" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="请填写商户号"
                                    v-decorator="[
                    'mid',
                    {rules: [{ required: true, message: '请填写商户号!' }],initialValue:info.chinaUMS.mid}
                  ]"
                            ></a-input>
                        </a-form-item>

                        <a-form-item label="消息来源(msgSrc)" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="消息来源"
                                    v-decorator="[
              'msgSrc',
              {rules: [{ required: true, message: '请输入消息来源!' }],initialValue:info.chinaUMS.msgSrc}
            ]"
                            ></a-input>
                        </a-form-item>

                        <a-form-item label="来源编号(msgSrcId)" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="来源编号"
                                    v-decorator="[
              'msgSrcId',
              {rules: [{ required: true, message: '请输入来源编号!' }],initialValue:info.chinaUMS.msgSrcId}
            ]"
                            ></a-input>
                        </a-form-item>

                        <a-form-item label="终端号(tid)" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="终端号"
                                    v-decorator="[
              'tid',
              {rules: [{ required: true, message: '请输入终端号!' }],initialValue:info.chinaUMS.tid}
            ]"
                            ></a-input>
                        </a-form-item>


                        <a-form-item label="密钥(key)" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
                            <a-input
                                    placeholder="密钥"
                                    v-decorator="[
              'key',
              {rules: [{ required: true, message: '请输入密钥!' }],initialValue:info.chinaUMS.key}
            ]"
                            ></a-input>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
                            <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        </a-form-item>
                    </a-form>
                </a-tab-pane>

                <a-tab-pane key="aliyun" tab="阿里云点播">
          <a-form :form="form6" @submit="aliyunSubmit">
          

            <a-form-item label="AppId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }">
              <a-input
                      placeholder="请填写appId"
                      v-decorator="[
                    'appId',
                    {rules: [{ required: true, message: '请填写appId!' }],initialValue:info.aliyun.appId}
                  ]"
              ></a-input>
            </a-form-item>

            <a-form-item label="AppSecret" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }" >
              <a-input
                      placeholder="请填写AppSecret"
                      v-decorator="[
                    'appsecret',
                    {rules: [{ required: true, message: '请填写AppSecret!' }],initialValue:info.aliyun.appsecret}
                  ]"
              ></a-input>
            </a-form-item>
            
            <a-form-item label="templateGroupId" :label-col="{ span: 5 }" :wrapper-col="{ span: 10 }" >
              <a-input
                      placeholder="请填写模板id"
                      v-decorator="[
                    'templateGroupId',
                    {rules: [{ required: false, message: '请填写模板id!' }],initialValue:info.aliyun.templateGroupId}
                  ]"
              ></a-input>
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 24, offset: 5 }" style="margin-top:20px;">
              <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
            </a-form-item>
          </a-form>
        </a-tab-pane>



            </a-tabs>
        </div>
    </div>
</template>
<script>
    var that;
    export default {
        name: "appVersion",
        data() {
            return {
                form: this.$form.createForm(this),
                form1: this.$form.createForm(this),
                form2: this.$form.createForm(this),
                form3: this.$form.createForm(this),
                form4: this.$form.createForm(this),
                form5: this.$form.createForm(this),
                form6: this.$form.createForm(this), //2021 09 23
                isloading: false,
                loadingTip: "加载中...",
                info: {
                    wechat: {
                        mchId: "",
                        mchKey: "",
                        appId: "",
                        notifyUrl: "",
                        appletsAppId: "",
                        keyContent: "",
                    },
                    alipay: {
                        gateway: "",
                        appId: "",
                        publicKey: "",
                        privateKey: "",
                        notifyUrl: "",
                    },
                    wxmp: {
                        appId: "",
                        secret: "",
                    },
                    sms: {
                        type: "",
                        account: "",
                        secret: "",
                        sign: "",
                    },
                    chinaUMS: {
                        key: "",
                        tid: "",
                        msgSrcId: "",
                        msgSrc: "",
                        mid: "",
                    },
                     // 2021 09 23 start
                      aliyun: {
                        appId: "",
                        appsecret: "",
                        templateGroupId:"",
                      },
                      // 2021 09 23 end 
                },
            };
        },
        mounted: function () {
            this.$nextTick(function () {
                that = this;
                this.getConfig();
            });
        },
        watch: {},
        methods: {
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    },
                });
            },
            getConfig() {
                this.isloading = true;
                this.$api.systemSetting
                    .getThirdConfig()
                    .then((res) => {
                        this.isloading = false;
                        if (res.errorCode == that.$msg.responseCode.success) {
                            if (res.data.alipay) {
                                this.info.alipay = res.data.alipay;
                            }
                            if (res.data.wechat) {
                                this.info.wechat = res.data.wechat;
                            }
                            if (res.data.wxmp) {
                                this.info.wxmp = res.data.wxmp;
                            }
                            if (res.data.sms) {
                                this.info.sms = res.data.sms;
                            }
                            if (res.data.chinaUMS) {
                                this.info.chinaUMS = res.data.chinaUMS;
                            }
                            // 2021 09 23 start
                            if (res.data.aliyun) {
                              this.info.aliyun = res.data.aliyun;
                            }
                            // 2021 09 23 end
                        } else {
                            this.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            // 2021 09 23 start
              aliyunSubmit(e) {
                e.preventDefault();
                this.form6.validateFields((err, values) => {
                  
                  if (!err) {

                    this.isloading = true;
                    this.$api.systemSetting
                            .setAliyunConfig(values)
                            .then((res) => {
                              this.isloading = false;
                              if (res.errorCode == that.$msg.responseCode.success) {
                                this.$message.success(res.errorMsg);
                              } else {
                                this.$message.error(res.errorMsg);
                              }
                            })
                            .catch(() => {
                              this.isloading = false;
                            });
                  }
                });
              },
              // 2021 09 23 end
            /**提交 */
            aliSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {

                        this.isloading = true;
                        this.$api.systemSetting
                            .setAlipayConfig(values)
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });
                    }
                });
            },
            wechatSubmit(e) {
                e.preventDefault();
                this.form1.validateFields((err, values) => {
                    if (!err) {
                        this.isloading = true;
                        this.$api.systemSetting
                            .setWechatConfig(values)
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });
                    }
                });
            },
            wxmpSubmit(e) {
                e.preventDefault();
                this.form2.validateFields((err, values) => {
                    if (!err) {
                        this.isloading = true;
                        this.$api.systemSetting
                            .setWxMpConfig(values)
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });
                    }
                });
            },
            smsSubmit(e) {
                e.preventDefault();
                this.form5.validateFields((err, values) => {
                    if (!err) {
                        console.log("进入了")
                        console.log(values)
                        this.isloading = true;
                        this.$api.systemSetting
                            .setSmsConfig(values)
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });
                    }
                });
            },

            chinaUMSSubmit(e) {
                e.preventDefault();
                this.form4.validateFields((err, values) => {
                    if (!err) {
                        console.log("进入了")
                        console.log(values)
                        this.isloading = true;
                        this.$api.systemSetting
                            .setChinaUMSConfig(values)
                            .then((res) => {
                                this.isloading = false;
                                if (res.errorCode == that.$msg.responseCode.success) {
                                    this.$message.success(res.errorMsg);
                                } else {
                                    this.$message.error(res.errorMsg);
                                }
                            })
                            .catch(() => {
                                this.isloading = false;
                            });
                    }
                });
            },
        },
    };
</script>


